import { map, catchError, tap } from 'rxjs/operators';
import { Injectable } from '@angular/core';

import { HttpClient, HttpHeaders, HttpEvent, HttpEventType } from '@angular/common/http';
import { httpOptions } from './database.service';
import * as JSZip from 'jszip';
import { API_ADDRESS_DEBUG, API_ADDRESS_INTERNET, API_ADDRESS_LOCAL, DEBUG_ENVIRONMENT } from '../_shared/constants';


@Injectable()
export class WebApiService {
   
    webApiMode: number = 0;
    constructor(private http: HttpClient) {

        let mode =  localStorage.getItem("webApiMode");

        if(mode!=null)
            {
              this.webApiMode = parseInt( localStorage.getItem("webApiMode"));
            }
            else
            {
                this.webApiMode = 0;
            }
            this.webApiMode = 0;
 
    }

    changeMode(mode: number) {
        localStorage.setItem("webApiMode",mode.toString());
      }

    post(path: string, data: any): Promise<any> {
        let body = JSON.stringify(data);
        return this.http.post(this.GetApiAddress() + `/${path}`, data, httpOptions)
            .pipe(tap(result => {
                return result;
            }), catchError(error => {

                throw error;

            }))
            .toPromise().then((result: any) => {


                return result;

            });

    }
    GetApiAddress() {
        let apiAddress;
        if (DEBUG_ENVIRONMENT) {
            apiAddress = API_ADDRESS_DEBUG;
        }
        else {
            if (this.webApiMode == 0 ) {
                apiAddress = API_ADDRESS_INTERNET;
            }
            if (this.webApiMode == 1) {
                apiAddress = API_ADDRESS_LOCAL;
            }
        }

        return apiAddress;
    }

    download(path: string, fileType: string, filename: string, progressFunc: (progress: any) => void): Promise<any> {


        let promise = new Promise<any>(resolve => {

            this.http.get(this.GetApiAddress() + `/${path}`, {
                responseType: "blob",
                reportProgress: true,
                observe: 'events'
            })
                .subscribe((event: HttpEvent<any>) => {

                    switch (event.type) {
                        case HttpEventType.Sent:
                            console.log('Request has been made!');
                            break;
                        case HttpEventType.ResponseHeader:
                            console.log('Response header has been received!');
                            break;
                        case HttpEventType.DownloadProgress:
                            let progress = Math.round(event.loaded / event.total * 100);
                            console.log(`Download! ${progress}%`);
                            break;
                        case HttpEventType.Response:
                            console.log('User successfully created!', event.body);

                            let result = event.body;

                            if (result.type != 'text/plain') {

                           
                                var new_zip = new JSZip();

                                // more files !
                                new_zip.loadAsync(result)
                                    .then(function (zip) {

                                        console.log(zip.files);
                                        zip.files[filename].async("string", (metadata) => {
                                            progressFunc(metadata.percent);
                                        })
                                            .then(data => {

                                                var blob = new Blob([data]);
                                                let saveAs = require('file-saver');
                                                let file = filename;
                                                saveAs(blob, file);
                                                resolve(blob);

                                                progressFunc(100);

                                            });

                                    });

                            }
                            else {

                                alert('File not found in Blob!');
                            }

                        //     resolve(event.body);


                    }
                },
                    err => console.log(err)
                );



            // }
            // );
        });

        return promise;
        // .map(
        //   (res) => {
        //         var blob = new Blob([res.blob()], {type: fileExtension} )
        //         return blob;            
        //   });

        // const httpOptions2 = {
        //     headers: new HttpHeaders({
        //         'Content-Type': 'plain/text',
        //         'Authorization': 'my-auth-token'
        //     })
        // };

        // return  this.http.get(this._webApi.GetApiAddress() + `/${path}`,httpOptions2)
        //    .pipe(tap(result => {
        //        return result;
        //    }), catchError(error => {

        //        throw error;

        //    }))
        //    .toPromise().then((result: any) => {


        //        return result;

        //    });


        //     const headers = new HttpHeaders().set('content-type', 'plain/text');


        //    return  this.http.get(this._webApi.GetApiAddress() + `/${path}`,
        //      { headers, responseType: 'blob' })
        //         .pipe(tap(result => {
        //             return result;
        //         }), catchError(error => {

        //             throw error;

        //         }))
        //         .toPromise().then((result: any) => {


        //             return result;

        //         });



    }


    upload(path: string, formData: FormData, fileType: string, progressFunc: (progress: any) => void): Promise<any> {



        let promise = new Promise<any>(resolve => {



            let progress = 0;



            //   this.fileDownloadInitiated = true;  
            this.http.post(this.GetApiAddress() + `/${path}`, formData
                , {
                    reportProgress: true,
                    observe: 'events',
                    headers: { 'enctype': 'multipart/form-data' } // Certifique-se de enviar como multipart
                })
                .subscribe((event: HttpEvent<any>) => {
                    switch (event.type) {
                        case HttpEventType.Sent:
                            console.log('Request has been made!');
                            break;
                        case HttpEventType.ResponseHeader:
                            console.log('Response header has been received!');
                            break;
                        case HttpEventType.UploadProgress:
                            progress = Math.round(event.loaded / event.total * 100);
                            console.log(`Uploaded! ${progress}%`);
                            progressFunc(progress);
                            break;
                        case HttpEventType.Response:
                            console.log('User successfully created!', event.body);

                            resolve(event.body);
                            setTimeout(() => {
                                progress = 0;
                            }, 1500);

                    }
                },
                    err => console.log(err)
                );
        });


        return promise;

    }


}
